import React, { useState } from "react";
import { Modal, Icon } from "antd";
export const InviteChatModal = ({
  open,
  handleClose,
  userList,
  handleInvite,
}) => {
  const [formData, setFormData] = useState(null);
  const [error, setError] = useState(null);
  const [userSearchQuery, setUserSearchQuery] = useState("");
  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    setUserSearchQuery(value);
  };
  const handleSave = async (user) => {
    setUserSearchQuery("");
    handleClose();
    handleInvite(user);
  };

  const searchData = (data, query) => {
    const lowercaseQuery = query.toLowerCase();
    return (
      data &&
      data.length > 0 &&
      data.filter((item) => {
        const name = item.name ? item.name.toLowerCase() : "";
        const email = item.email ? item.email.toLowerCase() : "";
        return email.includes(lowercaseQuery);
      })
    );
  };
  const filteredData =
    userList && userList && searchData(userList, userSearchQuery);

  return (
    <div>
      {" "}
      <Modal
        visible={open}
        footer={null}
        onOk={handleClose}
        onCancel={handleClose}
        closable={false}
        centered
      >
        <Icon
          type="close"
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#2a3da3",
            float: "right",
          }}
          onClick={() => {
            setUserSearchQuery("");
            handleClose();
          }}
        />
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h3 className="modaltitle">Invite User to Chat</h3>
        </div>

        <div style={{ marginBottom: "8px" }}>
          <h3 className="inputTitle">
            Enter Email <span style={{ color: "red" }}>*</span>
          </h3>
          <input
            className="roleInput"
            placeholder="Email"
            name="email"
            type="email"
            value={formData && formData.email}
            id="email"
            onChange={(e) => {
              e.preventDefault();
              e.persist();
              if (!isValidEmail(e.target.value)) {
                if (e.target.value === "") {
                  setError(null);
                } else {
                  setError("Email is invalid");
                }
              } else {
                setError(null);
              }
              handleChange(e.target.name, e.target.value);
            }}
          />
          {error && (
            <span style={{ color: "red", fontSize: "12px" }}>{error}</span>
          )}
        </div>
        <div
          style={{
            maxHeight: "23rem",
            overflowY: "scroll",
          }}
        >
          <div className="selectmain">
            {userSearchQuery && filteredData && filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <div
                  key={item.id}
                  onClick={() => {
                    handleSave(item);
                  }}
                  className="selectMaincards"
                  style={{ width: "98%" }}
                >
                  <div className="selectMaincardsInner">
                    {" "}
                    <div className="contact-chat-logo">
                      {item.name
                        ? item.name
                            .split(" ")
                            .map((part) => part[0])
                            .join("")
                        : "N/A"}
                    </div>
                    <div className="selectMainHeader">
                      <span
                        className="selectheadingValue"
                        style={{ fontSize: "16px" }}
                      >
                        {item.name}
                      </span>
                      <span
                        className="selectheadingValue"
                        style={{ fontSize: "14px", color: "#1c1c1c" }}
                      >
                        {item.email}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <h3
                className="inputTitle"
                style={{ textAlign: "center", width: "100%" }}
              >
                No User to Show
              </h3>
            )}
          </div>
        </div>
        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          {/*<button
            className="cancelbutton"
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </button> */}
          <button
            className="savebutton"
            // disabled={!formData || !formData.email || error}
            onClick={() => {
              setUserSearchQuery("");
              handleClose();
            }}
          >
            Close
          </button>
        </div>
      </Modal>
    </div>
  );
};
